var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lecture-list',{attrs:{"full-filtering":"","pagination":"","link-to-session":false,"lectures":_vm.lectures,"loading":_vm.loading,"total-items":_vm.totalItems},on:{"click:row":_vm.lectureDetail,"update:params":_vm.fetchLectures}})}
var staticRenderFns = []

export { render, staticRenderFns }